export type DateStyle = 'short' | 'long';

/*
  Strapi hands these down as date-only strings ("2026-05-21"), which JS parses
  as UTC midnight. Formatting them in the viewer's zone would render the
  previous day for anyone behind UTC, so both formatters pin timeZone to UTC.
  That also matches what the previous hand-rolled formatter did by accident: it
  split the string on "-" and never involved a timezone at all.
*/
const FORMATTERS: Record<DateStyle, Intl.DateTimeFormat> = {
  /*
    "May 5, 2026" — bylines on blog and press-release posts.

    The day is unpadded on purpose. The previous formatter read it straight out
    of the "2021-05-05" string and so wrote "May 05, 2021", which was an
    artefact of the string splitting rather than a decision, and left the
    bylines disagreeing with the release-note headings below.
  */
  short: new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }),
  // "May 5, 2026" with the month spelled out — release-note headings.
  long: new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }),
};

const formatDate = (date: string, style: DateStyle = 'short'): string =>
  FORMATTERS[style].format(new Date(date));

export default formatDate;
